import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Form, Card, Button, Spinner } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import "../../Styles/yellowcalfcss/PaidBills.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { useNavigate } from "react-router-dom";

const Eye = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

export function PaidBills() {
  /* ---------------- STATE ---------------- */
  const [filters, setFilters] = useState({
    billNumber: "",
    billDate: "",
  });
const navigate = useNavigate();
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH PAID BILLS ---------------- */
  useEffect(() => {
    fetchPaidBills();
  }, []);

  const fetchPaidBills = async () => {
    setLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
    };

    try {
      const response = await simplePostCall(
        ApiConfig.paidBills, // 👉 map this to /bill/paid_bill
        JSON.stringify(requestBody)
      );

      if (response?.result && Array.isArray(response.data)) {
        const normalized = response.data.map((item, index) => ({
          id: index + 1,
          billId : item.bill_id,
          billNumber: item.bill_number,
          supplier: item.supplier_name,
          billDate: item.bill_date,
          dueDate: item.bill_due_date,
          totalAmount:
            typeof item.bill_total_amount === "string"
              ? item.bill_total_amount
              : item.bill_total_amount || 0,
        }));

        setBills(normalized);
      } else {
        setBills([]);
      }
    } catch (error) {
      console.error("Paid bills fetch error:", error);
      setBills([]);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- FILTERING ---------------- */
  const filteredData = useMemo(() => {
    return bills.filter(
      (b) =>
        b.billNumber
          .toLowerCase()
          .includes(filters.billNumber.toLowerCase()) &&
        b.billDate.includes(filters.billDate)
    );
  }, [bills, filters]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleClear = () => {
    setFilters({ billNumber: "", billDate: "" });
  };

  /* ---------------- UI ---------------- */
  return (
    <div  className="financial-billing-main-area">
      <div className="billing-content-organizer">
        {/* HEADER */}
        <div className="spacing-unit-container">
          <Card className="title-display-module">
            <Card.Body>
              <h3 className="primary-heading-text">Paid Bills</h3>
            </Card.Body>
          </Card>
        </div>

        {/* FILTERS */}
        <div className="spacing-unit-container mt-4">
          <Row>
            <Col md={4} style={{ width: "20%"}}>
              <div style={{ position: "relative" }}>
                <FaSearch
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "-10px",
                    transform: "translateY(-50%)",
                    color: "#999",
                    fontSize: "14px",
                  }}
                />
                <Form.Control
                  type="text"
                  placeholder="Bill Number"
                  value={filters.billNumber}
                  onChange={(e) =>
                    handleFilterChange("billNumber", e.target.value)
                  }
                  className="transparent-search-field"
                  style={{ paddingLeft: "35px" }}
                />
              </div>
            </Col>

            <Col md={4} style={{ width: "" }}>
              <div style={{ position: "relative" }}>
                {/* <FaSearch
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "12px",
                    transform: "translateY(-50%)",
                    color: "#999",
                    fontSize: "14px",
                  }}
                /> */}
                {/* <Form.Control
                  type="text"
                  placeholder="Bill Date"
                  value={filters.billDate}
                  onChange={(e) =>
                    handleFilterChange("billDate", e.target.value)
                  }
                  className="transparent-search-field"
                  style={{ paddingLeft: "35px" }}
                /> */}
                <Button
                  onClick={handleClear}
                  className=""
                >
                  Clear
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        {/* TABLE */}
        <div className="spacing-unit-container">
          <div className="table-data-collection">
            <Card
              className="header-definition-card table-row-spacing"
              style={{ marginTop: "8px" }}
            >
              <Card.Body style={{ height: "60px" }}>
                <Row style={{ marginTop: "4px" }}>
                  <Col md={1} style={{ textAlign: "center", marginLeft: "18px" }}>
                    Sr No
                  </Col>
                  <Col md={2} style={{ textAlign: "center" }}>
                    Bill Number
                  </Col>
                  <Col md={2} style={{ textAlign: "center" }}>
                    Supplier
                  </Col>
                  <Col md={2} style={{ textAlign: "center" }}>
                    Bill Date
                  </Col>
                  <Col
                    md={2}
                    style={{ textAlign: "center", marginLeft: "65px" }}
                  >
                    Due Date
                  </Col>
                  <Col md={1} style={{ textAlign: "center" , position:"relative" }}>
                   <span style={{position:'absolute', right:'38%', bottom:'-38%'}}>Total Amount </span> 
                  </Col>
                  <Col md={1} style={{ textAlign: "center" }}>
                    Action
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* LOADING */}
            {loading && (
              <div className="text-center my-4">
                <Spinner animation="border" />
              </div>
            )}

            {/* NO DATA */}
            {!loading && filteredData.length === 0 && (
              <div className="text-center my-4 text-muted">
                No paid bills found
              </div>
            )}

            {/* ROWS */}
            {!loading &&
              filteredData.map((bill) => (
                <Card
                  key={bill.id}
                  className="record-display-card table-row-spacing"
                >
                  <Card.Body style={{ height: "45px" }}>
                    <Row style={{ marginTop: "-4px", fontSize: "14px" }}>
                      <Col
                        md={1}
                        style={{ textAlign: "center", marginLeft: "10px" }}
                      >
                        {bill.id}
                      </Col>
                      <Col md={2} style={{ textAlign: "center" }}>
                        {bill.billNumber}
                      </Col>
                      <Col md={2} style={{ textAlign: "center" }}>
                        {bill.supplier || "-"}
                      </Col>
                      <Col md={2} style={{ textAlign: "center" }}>
                        {bill.billDate}
                      </Col>
                      <Col
                        md={2}
                        style={{ textAlign: "center", marginLeft: "50px" }}
                      >
                        {bill.dueDate}
                      </Col>
                      <Col md={1} style={{ textAlign: "center" }}>
                        {bill.totalAmount === 0
                          ? "0"
                          : bill.totalAmount}
                      </Col>
                      <Col md={1} style={{ textAlign: "center" }}>
                         <Button className="icon-btn" onClick={() => navigate(`/accountant/paidBill/view/${bill.billId}`)}  title="View"><Eye /></Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
